import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useUsersMeCached } from '@helloworld1812/hr-api';
import { wsLocalStorage, wsSessionStorage } from '@helloworld1812/ws-storage';
import qs from 'qs';

import { useHrQuery } from '@/api';
import {
  UserOnboardingWelcomeModal,
  OnboardingStep,
  onboardingPageSteps,
} from '@/folder-components/user-onboarding-page';
import { ENABLE_MFE } from '@/config';

export function AuthorizedRedirects() {
  const location = useLocation();
  const isOnboardingPage = location.pathname === '/user-onboarding';
  const isLoginPage = location.pathname === '/login';
  const isSuccessLoginPage = location.pathname === '/success-login';
  const isRedirectPage = location.pathname === '/redirect';
  const { user } = useUsersMeCached();
  const onboardingStep = user.user_onboarding_desktop_step as OnboardingStep;
  const isSuperAdmin = user.is_super_admin;
  const { data: resetPwdTokenData } = useHrQuery(
    {
      url: '/v1/users/reset_password_token',
    },
    {
      enabled: !!user.reset_password_required,
    }
  );
  const resetPwdToken = resetPwdTokenData?.reset_password_token;

  if (resetPwdToken) {
    return <Redirect to={`/set-password/${resetPwdToken}`} />;
  }

  if (!isOnboardingPage && !isSuperAdmin && onboardingPageSteps.includes(onboardingStep)) {
    return <Redirect to="/user-onboarding" />;
  }

  const redirectUrl = wsSessionStorage.getRedirectUrl();

  if (redirectUrl != null) {
    wsSessionStorage.removeRedirectUrl();
    if (!ENABLE_MFE && redirectUrl.includes('/login')) {
      return null;
    }
    const authToken = wsLocalStorage.getWsToken();
    const wsCompanyId = wsLocalStorage.getWsCompanyId();
    const wsCompanyUuId = wsLocalStorage.getCoreCompanyId();

    const redirectUrlWithParams = `${redirectUrl}${qs.stringify(
      {
        auth: authToken,
        ws_company_id: wsCompanyId,
        ws_company_uuid: wsCompanyUuId,
      },
      { addQueryPrefix: true }
    )}`;

    return <Redirect to={redirectUrlWithParams} />;
  }

  // Authorized but still in unauthenticated flow
  if (isLoginPage || isSuccessLoginPage || isRedirectPage) {
    return <Redirect to="/" />;
  }

  // User is in the last welcome step of onboarding flow
  if (!isSuperAdmin && onboardingStep === 'welcome_modal') {
    return <UserOnboardingWelcomeModal />;
  }

  return null;
}
